import type { LandingHero } from "@/lib/api";

/**
 * The hero the storefront was built with. Mirrors DefaultLandingHero in the
 * API, and is what the prerendered HTML says: at build time there is no API.
 */
export const DEFAULT_HERO: LandingHero = {
  badge: "Dibuat di Indonesia",
  title: "Meja yang naik-turun\nikut kamu kerja.",
  subtitle:
    "Standing desk elektrik, dibuat sendiri di Indonesia. Harganya jelas di halaman produk, ongkirnya dihitung dari alamat kamu, dan tim kami bisa datang memasangnya.",
  ctaLabel: "Lihat semua meja",
  ctaHref: "/katalog",
  secondaryLabel: "Konsultasi dulu",
  secondaryHref: "whatsapp",
  slides: [],
  intervalSeconds: 6,
};

const KEY = "kanata:landing-hero";

/**
 * The hero this browser last saw. A returning visitor gets it straight away
 * instead of waiting on the API, and the fresh copy replaces it if the admin
 * has changed it since. A convenience only: blocked or wiped storage just
 * means waiting for the API, like a first visit.
 */
export function cachedHero(): LandingHero | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const h = JSON.parse(raw) as Partial<LandingHero>;
    return typeof h.title === "string" && Array.isArray(h.slides) ? { ...DEFAULT_HERO, ...h } : null;
  } catch {
    return null;
  }
}

export function rememberHero(h: LandingHero): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(h));
  } catch {
    // Storage full or blocked: the next visit waits on the API.
  }
}

/** The slide after `i`, wrapping round. */
export function nextSlide(i: number, count: number): number {
  return count <= 1 ? 0 : (i + 1) % count;
}

/** Whether an href leaves the storefront, so it opens as a plain link. */
export function isExternalHref(href: string): boolean {
  return /^https?:\/\//i.test(href);
}
